import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__saveSearch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
    var _params$path;
    var url, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          url = '/saved-search/save';
          data = {
            search_hash: params.search_hash,
            path: (params === null || params === void 0 ? void 0 : (_params$path = params.path) === null || _params$path === void 0 ? void 0 : _params$path.replace("?", '')) || '/filters',
            title: params.title,
            tags: JSON.stringify(params.tags)
          };
          _context.n = 1;
          return fetcher(null, true).post(url, data);
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function api__saveSearch(_x) {
    return _ref.apply(this, arguments);
  };
}();